import type { FaireProductEntity } from "../../entity_types/product";

export const p_m6bvrm4ms8: FaireProductEntity = {
  token: "p_m6bvrm4ms8",
  type: "product",
  name: "Gift Wrap - Dogs Surfing",
  brandName: "emmy+olly",
  imageUrl:
    "https://cdn.faire.com/fastly/056f44cf0c95c23cc60889c1afdda5a02164b6c771df44c55587d3e8f64b771d.jpeg",
  priceDollars: 2.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/680fe382f94096766f63a8c9cf35b916bbbb32e6670336be12fb6109914dcee8.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
